import * as React from 'react';

import { DispensaryContext } from './DispensaryProvider';
import { getFormattedTimeLabel } from '../deliveryWindows/scheduled-delivery-utils';

// Requires DispensaryProvider context 
const StoreHours = () => {

  const { dispensary: {hours_of_operation=[]}} = React.useContext(DispensaryContext);
  const [ formattedHours, setFormattedHours] = React.useState();

  // Format TODAY's business hours
  const getHoursDisplay = (hoursInfo) => {
    const openAt = getFormattedTimeLabel(hoursInfo.start_hour, hoursInfo.start_minute);
    const closeAt = getFormattedTimeLabel(hoursInfo.end_hour, hoursInfo.end_minute);
    // e.g. 9:00am - 5:00pm
    return `${openAt} - ${closeAt}`;
  } 
  
  React.useEffect(() => {
    if (hours_of_operation?.length) {
      const weekday = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLocaleLowerCase(); 
      const weekdayInfo = hours_of_operation.find((day) => day['weekday'] === weekday);
      if (weekdayInfo) {
        setFormattedHours(getHoursDisplay(weekdayInfo.hours));
      }  
    }
  }, [hours_of_operation]); 
  
  // 9:00am - 5:00pm, etc.
  return ( formattedHours 
    ? <>
        {`Store\u00A0Hours: `}
        <span style={{whiteSpace:'nowrap'}}>{formattedHours}</span>
      </>
    : null    
  )
}

export default StoreHours;